document.documentElement.classList.remove('no-js');

// Editorial shell ownership only. PDP, Quick View, cart and checkout behavior
// are owned exclusively by theme.js so commerce handlers are never bound twice.
document.addEventListener('DOMContentLoaded', () => {
  const drawer = document.querySelector('[data-editorial-mobile-drawer]');
  const openButton = document.querySelector('[data-editorial-menu-open]');
  const closeButtons = document.querySelectorAll('[data-editorial-menu-close]');

  const setExpanded = value => openButton?.setAttribute('aria-expanded', String(value));
  openButton?.addEventListener('click', () => {
    if (!drawer) return;
    if (typeof drawer.showModal === 'function') drawer.showModal();
    else drawer.setAttribute('open', '');
    setExpanded(true);
  });
  closeButtons.forEach(button => button.addEventListener('click', () => drawer?.close()));
  drawer?.addEventListener('close', () => setExpanded(false));
  drawer?.addEventListener('click', event => {
    if (event.target === drawer) drawer.close();
  });

  const desktopNodes = [...document.querySelectorAll('.editorial-menu--desktop .editorial-menu-node.has-children')];
  const closeDesktopNode = node => {
    node.classList.remove('is-open');
    node.querySelector(':scope > a')?.setAttribute('aria-expanded', 'false');
  };
  const openDesktopNode = node => {
    [...(node.parentElement?.children || [])].forEach(sibling => {
      if (sibling !== node && sibling.classList?.contains('is-open')) closeDesktopNode(sibling);
    });
    node.classList.add('is-open');
    const trigger = node.querySelector(':scope > a');
    trigger?.setAttribute('aria-haspopup', 'true');
    trigger?.setAttribute('aria-expanded', 'true');
  };
  desktopNodes.forEach(node => {
    const trigger = node.querySelector(':scope > a');
    trigger?.setAttribute('aria-haspopup', 'true');
    trigger?.setAttribute('aria-expanded', 'false');
    trigger?.addEventListener('click', event => {
      if (!window.matchMedia('(min-width:1025px)').matches) return;
      event.preventDefault();
      node.classList.contains('is-open') ? closeDesktopNode(node) : openDesktopNode(node);
    });
    trigger?.addEventListener('keydown', event => {
      if (event.key !== ' ') return;
      event.preventDefault();
      node.classList.contains('is-open') ? closeDesktopNode(node) : openDesktopNode(node);
    });
  });

  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    desktopNodes.filter(node => node.classList.contains('is-open')).forEach(node => {
      const restoreFocus = node.contains(document.activeElement);
      closeDesktopNode(node);
      if (restoreFocus) node.querySelector(':scope > a')?.focus({ preventScroll: true });
    });
  });
  document.addEventListener('pointerdown', event => {
    if (event.target.closest('.editorial-menu--desktop')) return;
    desktopNodes.filter(node => node.classList.contains('is-open')).forEach(closeDesktopNode);
  });

  const announcement = document.querySelector('[data-editorial-announcement]');
  const hideAnnouncement = document.querySelector('[data-editorial-announcement-hide]');
  const setAnnouncementHidden = hidden => {
    if (announcement) announcement.hidden = hidden;
    document.documentElement.classList.toggle('editorial-announcement-hidden', hidden);
  };
  let announcementHidden = false;
  try { announcementHidden = sessionStorage.getItem('editorialAnnouncementHidden') === 'true'; } catch {}
  setAnnouncementHidden(announcementHidden);
  hideAnnouncement?.addEventListener('click', () => {
    setAnnouncementHidden(true);
    try { sessionStorage.setItem('editorialAnnouncementHidden', 'true'); } catch {}
  });

  document.addEventListener('change', event => {
    const countrySelect = event.target.closest('[data-localization-select]');
    if (!countrySelect || !countrySelect.form || countrySelect.hasAttribute('onchange')) return;
    countrySelect.form.setAttribute('aria-busy', 'true');
    countrySelect.form.requestSubmit();
  });
  const closeLocalizationPickers = except => document.querySelectorAll('[data-localization-picker-menu]:not([hidden])').forEach(menu => {
    if (menu !== except) {
      menu.hidden = true;
      menu.closest('[data-localization-picker]')?.querySelector('[data-localization-picker-toggle]')?.setAttribute('aria-expanded', 'false');
    }
  });
  document.addEventListener('click', event => {
    const toggle = event.target.closest('[data-localization-picker-toggle]');
    if (toggle) {
      const picker = toggle.closest('[data-localization-picker]');
      const menu = picker?.querySelector('[data-localization-picker-menu]');
      if (!menu) return;
      const opening = menu.hidden;
      closeLocalizationPickers(opening ? menu : null);
      menu.hidden = !opening;
      toggle.setAttribute('aria-expanded', String(opening));
      if (opening) menu.querySelector('[data-localization-picker-option][aria-selected="true"]')?.focus({ preventScroll: true });
      return;
    }
    const option = event.target.closest('[data-localization-picker-option]');
    if (option) {
      const picker = option.closest('[data-localization-picker]');
      const select = picker?.querySelector('[data-localization-select]');
      if (!select || !option.dataset.countryCode) return;
      select.value = option.dataset.countryCode;
      picker.querySelectorAll('[data-localization-picker-option]').forEach(item => item.setAttribute('aria-selected', String(item === option)));
      picker.querySelector('[data-localization-picker-menu]')?.setAttribute('hidden', '');
      picker.querySelector('[data-localization-picker-toggle]')?.setAttribute('aria-expanded', 'false');
      select.form?.setAttribute('aria-busy', 'true');
      if (select.form?.requestSubmit) select.form.requestSubmit(); else select.form?.submit();
      return;
    }
    if (!event.target.closest('[data-localization-picker]')) closeLocalizationPickers(null);
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') closeLocalizationPickers(null);
  });
});
